const getRecursiveValue = (str: string, object: any): any => {
    if (!str) {
        return '';
    }

    const fce: any = (arr: any[], obj: any) => {
        const objKey = arr[0];
        const objKeyData = obj[objKey];
        const isObject = typeof objKeyData === 'object';

        if (arr.length === 1) {
            return objKeyData;
        }
        if (!isObject) {
            return null;
        }

        arr.shift();
        return fce(arr, objKeyData);
    };

    const arrStr = str.split('.');

    return fce(arrStr, object);
};

export default getRecursiveValue;
